// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__aN4Tb","savePackageButton":"ClientWallet_savePackageButton__KeE-7"};